import { cn } from "@/lib/utils";

/** Contenedor vertical de secciones (Opción A: acordeón + tarjetas internas). */
export function SatDownloadPanelStack({ children, className, ...props }) {
  return (
    <div className={cn("space-y-4", className)} {...props}>
      {children}
    </div>
  );
}

/** Tarjeta interna dentro de una pestaña del hub Descarga SAT. */
export function SatDownloadSectionCard({ title, children, className, contentClassName }) {
  return (
    <section
      className={cn(
        "rounded-lg border border-slate-200 bg-white shadow-sm p-4 space-y-3",
        className,
      )}
    >
      {title ? (
        <h4 className="text-[10px] font-bold uppercase tracking-wider text-slate-500 m-0">
          {title}
        </h4>
      ) : null}
      <div className={cn("space-y-3", contentClassName)}>{children}</div>
    </section>
  );
}

/** Encabezado introductorio de panel (icono + título + descripción). */
export function SatDownloadPanelIntro({ icon: Icon, iconWrapClassName, title, description }) {
  return (
    <SatDownloadSectionCard contentClassName="space-y-0">
      <div className="flex items-start gap-4">
        {Icon ? (
          <div className={cn("p-3 rounded-lg border shrink-0", iconWrapClassName)}>
            <Icon className="w-6 h-6" strokeWidth={1.75} />
          </div>
        ) : null}
        <div className="min-w-0">
          <h3 className="text-sm font-bold text-[#0F2D5C] m-0">{title}</h3>
          {description ? (
            <p className="text-xs text-slate-500 mt-1 mb-0 leading-relaxed">{description}</p>
          ) : null}
        </div>
      </div>
    </SatDownloadSectionCard>
  );
}
